<template>
    <BaseModal
        :isVisible="modalStatus"
        title="Veículo no Pátio"
        size="lg"
        @close="clean"
    >
        <template v-slot:content>
            <div class="row">
                <!-- Informações do Veículo -->
                <div class="col-md-5">
                    <ImageVehicle :vehicle-data="vehicleData"/>
                </div>

                <div class="col-md-7">
                    <div class="vehicle-info-container">
                        <section-container
                            title="Dados do Veículo"
                            icon="car-alt"
                        >
                            <div class="vehicle-data">
                                <div class="data-row">
                                    <div class="data-label">
                                        <i class="fas fa-car-side"></i>
                                        Veículo:
                                    </div>
                                    <div class="data-value">
                                        {{ vehicleData.description }} {{ vehicleData.color }}
                                    </div>
                                </div>

                                <div class="data-row">
                                    <div class="data-label">
                                        <i class="fas fa-hashtag"></i>
                                        Placa:
                                    </div>
                                    <div class="data-value plate">
                                        {{ vehicleData.board }}
                                    </div>
                                </div>

                                <div class="data-row">
                                    <div class="data-label">
                                        <i class="fas fa-tachometer-alt"></i>
                                        Km do Veículo:
                                    </div>
                                    <div class="data-value km-value">
                                        {{ formatNumber(vehicleData.current_km) }}
                                    </div>
                                </div>
                            </div>

                            <div class="action-buttons mt-4">
                                <router-link to="/myreserves/add">
                                    <button
                                        class="btn btn-primary"
                                    >
                                        <i class="fas fa-calendar-check mr-2"></i>
                                        Agendar Reserva
                                    </button>
                                </router-link>
                            </div>
                        </section-container>
                    </div>
                </div>
            </div>

            <!-- Histórico de Viagens -->
            <LastTripsTable
                :vehicle-data="vehicleData"
                :total-trips="totalTrips"
                @open-trip-details="openTripDetails"
                @load-page="loadPage"
            />
        </template>
    </BaseModal>
</template>

<script>
import BaseModal from '../Base/BaseModal.vue';
import {Pagination} from 'vue-pagination-2';
import SectionContainer from "./Checklist/SectionContainer.vue";
import LastTripsTable from "./Components/LastTripsTable.vue";
import ImageVehicle from "./Components/ImageVehicle.vue";

export default {
    name: "PatioVehicleModal", // Nome do componente em inglês: Modal de Veículo no Pátio
    components: {
        ImageVehicle,
        SectionContainer,
        LastTripsTable,
        BaseModal,
        Pagination
    },
    props: {
        modalStatus: { // modalStatus - status do modal se está aberto ou fechado
            type: Boolean,
            default: false
        },
        dataModal: { // dataModal - dados do veículo a serem exibidos no modal
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            currentPage: 0, // currentPage - página atual da paginação
            tripsPerPage: 5, // tripsPerPage - quantidade de viagens por página
            paginationOptions: {
                texts: {
                    count: "Mostrando {from} de {to} até {count} de registros",
                },
                page: 1,
                chunk: 4,
                chunksNavigation: "fixed",
            }
        };
    },
    computed: {
        vehicleData() { // vehicleData - dados do veículo computados a partir do dataModal
            return this.dataModal || {};
        },
        totalTrips() { // totalTrips - total de viagens para paginação
            return this.dataModal && this.dataModal.last_trips ? this.dataModal.last_trips.total : 0;
        }
    },
    methods: {
        formatNumber(value) {
            if (!value) return '0';
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        openTripDetails(trip) {
            this.$emit('OMDCk', trip);
            this.$emit('changeModal', false);
        },
        loadPage(page) {
            this.$emit('openModals', this.vehicleData.id, this.vehicleData.status, this.vehicleData, page);
        },
        clean() {
            this.$emit('changeModal', false);
        }
    }
};
</script>

<style scoped>
.vehicle-image-container {
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    margin-bottom: 1rem;
    height: 220px;
}

.vehicle-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.vehicle-badge {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0));
    color: white;
    padding: 15px 10px 10px;
    font-weight: bold;
    font-size: 16px;
    text-align: center;
}

.vehicle-info-container {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.vehicle-data {
    background-color: #f8f9fa;
    border-radius: 6px;
    padding: 15px;
    margin-bottom: 15px;
}

.data-row {
    display: flex;
    margin-bottom: 12px;
    align-items: center;
}

.data-row:last-child {
    margin-bottom: 0;
}

.data-label {
    width: 120px;
    font-weight: 600;
    color: #495057;
}

.data-value {
    flex: 1;
    padding-left: 10px;
}

.plate {
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 3px 8px;
    font-weight: bold;
    display: inline-block;
}

.km-value {
    font-weight: bold;
    color: #0056b3;
}

.action-buttons {
    display: flex;
    justify-content: flex-end;
}

.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px 0;
}

.empty-state i {
    font-size: 48px;
    opacity: 0.5;
}

.user-cell, .date-cell {
    display: flex;
    align-items: center;
}

.pagination-container {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}

@media (max-width: 767px) {
    .vehicle-image-container {
        height: 180px;
    }

    .data-row {
        flex-direction: column;
        align-items: flex-start;
    }

    .data-label {
        width: 100%;
        margin-bottom: 5px;
    }

    .data-value {
        padding-left: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/AvailableModal.vue